module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left pb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.back($event)
      }
    }
  }, [_vm._v("← retour")])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "text-xs-left headline"
  }, [_vm._v("Administration")]), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-subheader', [_vm._v("Actions")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.reset($event)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Réinitialiser la tablette")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Cela effacera toutes les données")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": "",
      "ripple": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-1"
  }, [_vm._v("replay")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Merci de renseigner le mot de passe administrateur"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31613606","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 318
// module chunks = 1